import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-158e2e68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner-container" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["swiper-header-container", { 'disable-auto': !_ctx.autoRef }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["swiper-item", { active: item.active }]),
          key: index,
          onClick: ($event: any) => (_ctx.onClickItem(item, index))
        }, _toDisplayString(item.activityTypeName), 11, _hoisted_2))
      }), 128))
    ])
  ], 2))
}